export default "__VITE_ASSET__B1yKKaIL__"